// extracted by mini-css-extract-plugin
module.exports = {"container":"bQ_x","anchorSectionContainer":"bQ_fj","anchorSectionText":"bQ_fN","mobileLink":"bQ_cH"};